import { Outlet } from "react-router-dom";

import { Stack } from "~/components/ui/stack";
import { Header } from "~/components/common/header";

export const AvailabilityMapLayout = () => (
  <Stack direction="column" sx={{ height: "100vh" }}>
    <Header />
    <main style={{ position: "relative", width: "100%", height: "100%" }}>
      <Outlet />
    </main>
  </Stack>
);
